/**
 * 模板市场-选项卡动作定义
 * @author VenDream
 * @since 17/10/19
 */

import ACTIONS from 'constants/action.json5';

// 设置激活的Tab
export function setActiveTab(index) {
  return {
    type: ACTIONS.SET_ACTIVE_TAB,
    index,
  };
}
